import { axiosApi } from 'app/api/api';
import { cloneDeep } from 'lodash-es';
import {
  ExplorerEntityTypes,
  SortContentKey,
  SortContentOrder,
} from 'entities/types';
import { FileData, RestoreFileParams } from 'entities/file/model/fileModel';
import {
  FolderData,
  RestoreFolderParams,
} from 'entities/folder/model/folderModel';
import { SectionData } from 'entities/section/model/sectionModel';
import { RestoreTableParams, TableData } from 'entities/table/model/tableModel';
export const trashApi = {
  fetchTrash: async () => {
    const res = await axiosApi.get<{
      files?: FileData[];
      tables?: TableData[];
      folders?: FolderData[];
      sections?: SectionData[];
    }>(`/trash/`);

    return res.data;
  },

  fetchContent: async (params: {
    sort_by: SortContentKey;
    sort_direction: SortContentOrder;
  }) => {
    const res = await axiosApi.get<{ content: any[] }>(`/trash/content`, {
      params,
    });

    return res.data.content;
  },

  restoreFile: async (id: string, params: RestoreFileParams) => {
    const restore_place_id = params.folder_id || params.section_id;

    await axiosApi.get(`/trash/restore/file/${id}`, {
      params: { restore_place_id },
    });

    return true;
  },
  restoreTable: async (id: string, params: RestoreTableParams) => {
    const restore_place_id = params.folder_id || params.section_id;

    await axiosApi.get(`/trash/restore/table/${id}`, {
      params: { restore_place_id },
    });

    return true;
  },
  restoreFolder: async (id: string, params: RestoreFolderParams) => {
    await axiosApi.get(`/trash/restore/folder/${id}`, {
      params: {
        entity_type: params.folderId
          ? ExplorerEntityTypes.FOLDER
          : ExplorerEntityTypes.SECTION,
        restore_place_id: params.folderId || params.sectionId,
      },
    });

    return true;
  },
  restoreSection: async (id: string) => {
    await axiosApi.get(`/trash/restore/section/${id}`);

    return true;
  },

  deleteFile: async (id: string) => {
    await axiosApi.delete(`/trash/delete/file/${id}`);

    return true;
  },
  deleteTable: async (id: string) => {
    await axiosApi.delete(`/trash/delete/table/${id}`);

    return true;
  },
  deleteFolder: async (id: string) => {
    await axiosApi.delete(`/trash/delete/folder/${id}`);

    return true;
  },
  deleteSection: async (id: string) => {
    await axiosApi.delete(`/trash/delete/section/${id}`);

    return true;
  },

  deleteAll: async () => {
    await axiosApi.delete(`/trash/delete_all`);

    return true;
  },

  restoreAll: async (params: {
    entityType: ExplorerEntityTypes;
    sectionId?: string;
    folderId?: string;
  }) => {
    await axiosApi.get(`/trash/restore_all`, {
      params,
    });

    return true;
  },
};
